// extracted by mini-css-extract-plugin
export var actionButton = "_fd-0";
export var fileInput = "_fd-2";
export var paperclip = "_fd-1";